<template>
  <div class="online_comment main">
    <div class="top-tips">提交评价或建议，可以帮助骑手和商家做的更好哦～</div>
    <!-- 对骑手评价 -->
    <div class="card" v-if="mainInfo.deliveryName">
      <div class="card-title">
        <div>您对西游侠配送满意吗？</div>
        <div class="right">已对西游侠匿名</div>
      </div>
      <div class="card-cnt">
        <div class="delivery-info">
          <img :src="mainInfo.deliveryImage" alt="">
          <div>{{mainInfo.deliveryName}}</div>
        </div>
        <div class="delivery-comment">
          <div class="options">
            <div class="item" v-bind:class="{'checked': item.checked}" v-for="item in deliveryScores" v-bind:key="item.id" @click="checkDeliveryScore(item)"></div>
          </div>
          <div v-if="deliveryScores[0].checked">
            <div class="tips">*请选择原因，我们会督促骑手</div>
            <ul class="tags">
              <li v-for="item in mainInfo.badDeliveryTemplateList" v-bind:key="item.estimateCode" v-bind:class="{'checked': item.checked}" @click="checkBadDeliveryTag(item)">{{item.estimateDesc}}</li>
            </ul>
            <div class="input-box">
              <textarea name="deliveryComment" id="deliveryComment" maxlength="100" v-model="deliveryComment"  placeholder="非常抱歉，您的反馈会督促我们做的更好"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对商家或菜品评价 -->
    <div class="card">
      <div class="card-title">
        <div>您对商家/菜品满意吗？</div>
        <div class="right" @click="selectAnonymous">
          <span class="anonymous_btn" v-bind:class="{'selected': selected}"></span>
          匿名提交
        </div>
      </div>
      <div class="card-cnt">
        <div class="shop-info" style="margin-bottom: .4rem">
          <img :src="mainInfo.shopImage" alt="">
          <div>{{mainInfo.shopName}}</div>
        </div>
        <div class="shop-comment">
          <div class="stars" v-for="(star,index) in stars" v-bind:key="index">
            <div v-if="star.isShow">
              <span>{{star.title}}</span>
              <ul>
                <li v-for="(item,index1) in star.list" v-bind:key="index1" v-bind:class="{'active': item.active}"  @click="tapStar(star,index1)"></li>  
              </ul>
              <span>{{star.desc}}</span>
            </div>
          </div>
          <div class="input-box">
            <textarea name="comment" id="comment" maxlength="100" v-model="comment"  placeholder="写下用餐感受，给大家参考～"></textarea>
            <div class="addPic">
              <ul>
                <li class="fl upLoadPic" v-for="(item,index) in goodsImages" v-bind:key="index">
                  <div v-bind:style="{backgroundImage: 'url('+item+')'}"></div>
                  <span @click="deletepic(index)"></span>
                </li>
              </ul>
              <div class="addPicBtn" v-show="isAddShow">
                <form id='uploadForm' method="post" enctype="multipart/form-data"><input type="file" id="uploadImg" accept="image/*" v-on:change="getImage($event)"/></form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 对商品评价 -->
    <div class="card">
      <ul class="goods-list">
          <li v-for="(item,index) in goodsList" v-bind:key="index">
            <div class="flex-row-sc">
              <img :src="item.image" style="width: .52rem;height:.52rem;border-radius:.08rem;margin-right:.16rem">
              <div class="name">{{item.name}}</div>
            </div>
            <div class="flex-row-sc">
              <div @click="selectClick(item,'bad',index)" class="bad" :class="{'active': item.scoreType==1}"></div>
              <div @click="selectClick(item,'good',index)" class="good" :class="{'active': item.scoreType==2}"></div>
            </div>
          </li>
        </ul>
    </div>
    <div class="fixed-bottom">
      <div class="btn" @click="submit">提交点评</div>
    </div>
    <!--评价完成弹窗-->
    <div class="alert_mask fixed" v-if="isOk" @touchmove.prevent>
      <div class="alert_con">
        <div class="img"></div>
        <p>感谢您的评价</p>
        <p>让我们做的更好～</p>
        <div class="ok" @click="confirm">确定</div>
      </div>
    </div>
    <!--评价完成弹窗-->
  </div>
</template>

<script>
    import {actions} from '../store/actions'
    import PreviewPicture from "../components/PreviewPicture"
    // import { MessageBox, Indicator,Toast} from 'mint-ui'
    import Vue from 'vue'

    export default {
      name:'mycomment',
      data () {
        return {
          orderId: window.localStorage.getItem('orderCode'),
          isOk: false,
          isAddShow: true,
          switchbad: [],
          switchgood: [],
          selected: false,
          score: 0,
          complaintList: [],
          remnant: 100,
          mainInfo: {},
          goodsList:[],
          goodsMarkList: [],
          goodsImages: [],
          // canSubmit: false,
          // estimateTemplateList: [],
          comment: '',
          deliveryComment: '',
          qualityScore: 0, // 订单
          packScore: 0, // 包装
          tasteScore: 0, // 味道
          stars: [
            {
              isShow: true,
              id: 1,
              title: '总体',
              list: [
                { id: 1, active: 0 },
                { id: 2, active: 0 },
                { id: 3, active: 0 },
                { id: 4, active: 0 },
                { id: 5, active: 0 }
              ],
              desc: ''
            },
            {
              isShow: false,
              id: 2,
              title: '口味',
              list: [
                { id: 1, active: 0 },
                { id: 2, active: 0 },
                { id: 3, active: 0 },
                { id: 4, active: 0 },
                { id: 5, active: 0 }
              ],
              desc: ''
            },
            {
              isShow: false,
              id: 3,
              title: '包装',
              list: [
                { id: 1, active: 0 },
                { id: 2, active: 0 },
                { id: 3, active: 0 },
                { id: 4, active: 0 },
                { id: 5, active: 0 }
              ],
              desc: ''
            }
          ],
          deliveryScores: [
            {id: 1, desc: '不满意', score: 85, checked: false},
            {id: 2, desc: '满意', score: 100, checked: false}
          ]
        }
      },
      computed: {
        wxUid () {
          return this.$store.state.wxUid
        }
      },
      created (){
        var _this = this
        document.title = '写点评'
        _this.getOnlineCommentInfo()

      },
      computed:{ //计算属性
        itemClasses(){
          let result = []; // 返回的是一个数组,用来遍历输出星星
          let integer = this.score;
          for(let i=0;i<integer;i++){ // 整数星星使用on
            result.push("on"); // 一个整数星星就push一个CLS_ON到数组
          }
          while(result.length < 5){// 余下的用无星星补全,使用off
            result.push("off");
          }
          console.log(result)
          return result;
        }
      },
      methods: {
        getOnlineCommentInfo: function (){
          var _this = this
          var params = {
            orderId: _this.orderId
          }
          actions.getOnlineCommentInfo(_this, params, function (data) {
            for (var i = 0; i < data.goodsList.length; i++) {
              data.goodsList[i].scoreType = 0
            }
            if(data.badDeliveryTemplateList && data.badDeliveryTemplateList.length > 0){
              for (var i = 0; i < data.badDeliveryTemplateList.length; i++) {
                data.badDeliveryTemplateList[i].checked = false
              }
            }
            _this.mainInfo = data
            _this.goodsList = data.goodsList
            // _this.estimateTemplateList = data.estimateTemplateList
          })
        },
        checkDeliveryScore: function(item) {
          for(let v of this.deliveryScores){
            v.checked = false;
          }
          item.checked = true;
        },
        checkBadDeliveryTag: function(item) {
          item.checked = !item.checked;
        },
        tapStar(parent,index) {
          for(let i = 0; i < this.stars.length; i++){
            if(parent.title == this.stars[i].title){
              let list = this.stars[i].list;
              for(let j = 0; j < list.length; j++){
                if(j <= index){
                  list[j].active = 1;
                  let array = ['非常差','差','一般','好','超赞'];
                  this.stars[i].desc = array[index];

                  if(this.stars[i].id == 1){
                    this.qualityScore = index + 1;
                  }else if(this.stars[i].id == 2){
                    this.tasteScore = index + 1;
                  }else if(this.stars[i].id == 3){
                    this.packScore = index + 1;
                  }
                }else{
                  list[j].active = 0;
                }
              }
            }
            if(parent.id == 1){
              this.stars[i].isShow = true;
              if(index == 4){
                let list = this.stars[i].list;
                for(let j = 0; j < list.length; j++){
                  list[j].active = 1;
                  this.stars[i].desc = '超赞';
                  this.qualityScore = index + 1;
                  this.tasteScore = index + 1;
                  this.packScore = index + 1;
                }
              }
            }
          }
          // item.active = 1;

        },
        // shortcutsSelect: function(text){
        //   var _this = this
        //   if(_this.desc.length <= 100){
        //     if(_this.desc == ''){
        //       _this.desc = _this.desc+text
        //     }else if(_this.desc != ''){
        //       _this.desc = _this.desc+'，'+text
        //     }
        //   }
        //   _this.descInput()
        // },
        // descInput(){
        //   var _this = this
        //   var txtVal = _this.desc.length;
        //   if(txtVal<=100) {
        //     _this.remnant = 100 - txtVal;
        //   }
        // },
        // stars: function(index){
        //   this.score = index + 1
        //   // this.validateSubmit()
        // },
        selectClick(item,type,index){
          var _this = this
          var goodsList = []
          for(var i=0;i<_this.goodsList.length;i++) {
            if( i == index) {
              if(item.scoreType == 0) {
                if(type=='good') {
                  item.scoreType = 2
                } else {
                  item.scoreType = 1
                }
              } else if(item.scoreType == 1){
                if(type=='good') {
                  item.scoreType = 2
                } else {
                  item.scoreType = 0
                }
              } else if(item.scoreType == 2) {
                if(type=='bad') {
                  item.scoreType = 1
                } else {
                  item.scoreType = 0
                }
              }
            }
            goodsList.push(_this.goodsList[i])
          }

          _this.goodsList = goodsList
          for (var i=0; i < _this.goodsList.length; i++){
            _this.goodsMarkList[i] = {
              skuCode: _this.goodsList[i].skuCode,
              goodsScore:_this.goodsList[i].scoreType
            }
          }
          // _this.validateSubmit()
        },
        // validateSubmit: function (){
        //   var  _this = this
        //
        //   for(var i = 0; i < _this.goodsMarkList.length; i++){
        //     if(_this.score > 0 && _this.goodsMarkList[i].goodsScore != 0 ) {
        //       _this.canSubmit = true
        //     }else{
        //       _this.canSubmit = false
        //       break;
        //     }
        //   }
        //
        // },
        // 提交成功弹框
        confirm: function (){
          this.isOk = false
          this.$router.go(-1);
        },

        //上传图片
        getImage: function(e){
          var _this = this
          let host = _this.$utils.getSpliceHost('manager-center')
          var url = host+'/api/fileupload/upBase64'
          let file = e.target.files[0];
          if (!/image\/\w+/.test(file.type)) {
            _this.$messagebox.alert('请选择图片','')
            return false;
          }

          _this.$indicator.open()//loading

          // 通过canvas压缩图片
          var reader = new FileReader();
          reader.readAsDataURL(file);
          var img = new Image;
          reader.onload = function (e) {
            var width = 320, //图像大小
              quality = 0.8, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            img.src = this.result;
            img.onload = function () {
              canvas.width = width;
              canvas.height = width * (img.height / img.width);
              drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
              let imgsrc = canvas.toDataURL("image/png", quality);
              _this.$http.post(url, {src:imgsrc},{emulateJSON: true}).then(function (response) {
                _this.goodsImages.push(response.body.data.path)
                if(_this.goodsImages.length>=3){
                  _this.isAddShow = !_this.isAddShow
                }
                _this.$indicator.close();
                // 响应成功回调
              }, function (response) {
                // 响应错误回调
                _this.$indicator.close();
              })
            }
          }
        },

        // 删除图片
        deletepic: function (index){
          var _this = this
          _this.goodsImages.splice(index,1)
          if (!_this.isAddShow) {
            _this.isAddShow = !_this.isAddShow
          }
        },
        selectAnonymous: function (){
          this.selected = !this.selected
        },
        submit: function () {
          let _this = this;
          let deliveryScore = 0,
          deliveryEstimateInfoList = [];
          if(_this.mainInfo.deliveryName){
            if(!_this.deliveryScores[0].checked && !_this.deliveryScores[1].checked){
              _this.$toast('请评价骑手服务');
              return false;
            }else{
              for(let v of _this.deliveryScores){
                  if(v.checked){
                    deliveryScore = v.score;
                  }
                }
              if(_this.deliveryScores[0].checked){
                for(let v of this.mainInfo.badDeliveryTemplateList){
                  if(v.checked){
                    deliveryEstimateInfoList.push(v);
                  }
                }
                if(deliveryEstimateInfoList.length == 0){
                  _this.$toast('请选择骑手问题');
                  return false;
                }
              }
            }
          }
          
          if(_this.qualityScore === 0){
            _this.$toast('请评价商家');
            return false;
          }
          if(_this.tasteScore === 0){
            _this.$toast('请给口味评分');
            return false;
          }
          if(_this.packScore === 0){
            _this.$toast('请给包装评分');
            return false;
          }
          if(_this.goodsMarkList.length == 0){
            _this.$toast('需要对菜品打分哦~');
            return false;
          }
          for(var i = 0; i < _this.goodsMarkList.length; i++){
            if(_this.goodsMarkList[i].goodsScore == 0 ) {
              _this.$toast('需要对菜品打分哦~');
              return false;
            }
          }
          var anonymous
          if (_this.selected) {
            anonymous = 1
          }else{
            anonymous = 0
          }
          var params = {
            orderId: _this.orderId,
            goodsMarkList: _this.goodsMarkList, //商品打分列表
            anonymous: anonymous,//是否匿名
            comment: _this.comment,//评论内容
            imageList: _this.goodsImages, //图片列表
            packScore: _this.packScore,
            tasteScore: _this.tasteScore,
            qualityScore: _this.qualityScore
          }
          if(_this.mainInfo.deliveryName){
            params.deliveryScore = deliveryScore;
            params.deliveryComment = _this.deliveryComment;
            params.deliveryEstimateInfoList = deliveryEstimateInfoList;
          }
          actions.postSaveComment(_this, params, function () {
            _this.isOk = true
            // 提交成功的回调
          }, function (response) {
            _this.$toast(response.body.message,'')
            // 错误回调
          })
        }
      },
      components: {
        PreviewPicture
      }
    }

</script>
<style scoped>
  .online_comment.main{
    padding: 0 0 2rem 0;
  }
  .online_comment .top-tips{
    width: 100%;
    height: .65rem;
    line-height: .65rem;
    background: rgba(246, 242, 196, 1);
    padding-left: .3rem;
    color: #FF8700;
    font-size: .24rem;
  }
  .online_comment .card{
    margin: .2rem .32rem 0 .32rem;
    background: #FFFFFF;
    border-radius: .16rem;
    padding: 0 .24rem;
  }
  .online_comment .card .card-title{
    display: flex;
    height: .94rem;
    justify-content: space-between;
    align-items: center;
    font-size: .32rem;
    font-weight: 600;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
  .online_comment .card .card-title .right{
    color: #666;
    font-size: .2rem;
    display: flex;
    align-items: center;
  }
  .online_comment .card .card-cnt{
    padding: .23rem 0;
  }
  .online_comment .card .card-cnt .delivery-info,
  .online_comment .card .card-cnt .shop-info{
    display: flex;
    align-items: center;
  }
  .online_comment .card .card-cnt .delivery-info img,
  .online_comment .card .card-cnt .shop-info img{
    width: .72rem;
    height: .72rem;
    margin-right: .16rem;
    border-radius: .08rem;
    font-size: .28rem;
  }
  .online_comment .card .card-cnt .delivery-comment {
    margin-top: .24rem;
  }
  .online_comment .card .card-cnt .delivery-comment .options{
    display: flex;
    justify-content: space-between;
  }
  .online_comment .card .card-cnt .delivery-comment .options .item{
    width: 3.11rem;
    height: .68rem;
    /* background: #F6F6F6; */
    border-radius: .08rem;
    text-align: center;
    line-height: .68rem;
    color: #666666;
    font-size: .28rem;
    background-image: url(../assets/images/bg-manyi.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  .online_comment .card .card-cnt .delivery-comment .options .item:first-child{
    background-image: url(../assets/images/bg-nomanyi.png);
  }
  .online_comment .card .card-cnt .delivery-comment .options .item.checked{
    background-image: url(../assets/images/bg-manyi-active.png);
  }
  .online_comment .card .card-cnt .delivery-comment .options .item:first-child.checked{
    background-image: url(../assets/images/bg-nomanyi-active.png);
  }
  .online_comment .card .card-cnt .delivery-comment .tips{
    font-size: .2rem;
    color: #FF4A61;
    padding: .16rem 0 .24rem 0;
  }
  .online_comment .card .card-cnt .delivery-comment .tags{
    display: flex;
    flex-flow: wrap;
  }
  .online_comment .card .card-cnt .delivery-comment .tags li{
    height: .4rem;
    line-height: .4rem;
    padding: 0 .17rem;
    text-align: center;
    background: #F6F6F6;
    border-radius: .08rem;
    color: #666666;
    font-size: .2rem;
    margin: 0 .16rem .16rem 0;
  }
  .online_comment .card .card-cnt .delivery-comment .tags li.checked{
    background: rgba(255, 251, 205, 1);
    color: #FF8700;
  }
  .online_comment .card .card-cnt .delivery-comment .input-box{
    width: 6.38rem;
    height: 1.5rem;
    background: #F6F6F6;
    border-radius: .16rem;
    padding: .24rem;
  }
  .online_comment .card .card-cnt .delivery-comment textarea{
    font-size: .2rem;
    color: #666;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .online_comment .card .card-cnt .shop-comment .stars > div{
    display: flex;
    align-items: center;
    margin-bottom: .24rem;
    font-size: .2rem;
    color: #666;
  }
  .online_comment .card .card-cnt .shop-comment .stars span:first-child{
    width: .9rem;
  }
  .online_comment .card .card-cnt .shop-comment .stars ul{
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    /* width: 3rem; */
    /* margin: 0 .35rem; */
  }
  .online_comment .card .card-cnt .shop-comment .stars li{
    width: .42rem;
    height: .39rem;
    margin-right: .27rem;
    background-image: url("../assets/images/star2.png");
    background-repeat: no-repeat;
    background-size: .28rem auto;
    background-position: center center;
  }
  .online_comment .card .card-cnt .shop-comment .stars li.active{
    background-image: url("../assets/images/star2-active.png");
  }
  .online_comment .card .card-cnt .shop-comment .stars:first-child{
    font-size: .28rem;
    color: #333333;
    font-weight: bold;
  }
  .online_comment .card .card-cnt .shop-comment .stars:first-child li{
    background-size: 100% auto;
  }
  .online_comment .card .card-cnt .shop-comment .input-box{
    width: 6.39rem;
    /* height: 2.14rem; */
    background: #F6F6F6;
    border-radius: .16rem;
    padding: .24rem;
  }
  .online_comment .card .card-cnt .shop-comment .input-box textarea{
    width: 5.8rem;
    height: .7rem;
    padding: 0;
    font-size: .2rem;
  }
  .online_comment .addPic{
    display: flex;
    background: transparent;
    padding: .3rem 0 0;
  }
  .online_comment .addPic .addPicBtn{
    background-image: url("../assets/images/aly_selected_image_icon@2x.png")
  }
  .online_comment .goods-list{
    padding: .24rem 0 0 0;
  }
  .online_comment .goods-list li{
    height: .52rem;
    margin-bottom: .24rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: .28rem;
  }
  .online_comment .goods-list li .good,
  .online_comment .goods-list li .bad{
    width: 0.77rem;
    height: 0.36rem;
  }
  .online_comment .goods-list li .good{
    background: url('../assets/images/good-default.png') no-repeat;
    background-size: .36rem;
    background-position: center right;
    }
  .online_comment .goods-list li .good.active{
    background: url('../assets/images/good.png') no-repeat;
    background-size: .36rem;
    background-position: center right;
  }
  .online_comment .goods-list li .bad{
    background: url('../assets/images/bad-default.png') no-repeat;
    background-size: .36rem;
    background-position: center right;
  }
  .online_comment .goods-list li .bad.active{
    background: url('../assets/images/bad.png') no-repeat;
    background-size: .36rem;
    background-position: center right;
  }
  .online_comment .anonymous_btn{
    display: block;
    width: 0.24rem;
    height: 0.24rem;
    margin-right: .12rem;
    border: 1px solid #9B9B9B;
    border-radius: 50%;
  }
  .online_comment .anonymous_btn.selected{
    background: url('../assets/images/icon_choose@2x.png') no-repeat;
    background-size: 100% auto;
    border: none;
  }
  .online_comment .fixed-bottom{
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: .24rem;
    background: #fff;
  }
  .online_comment .fixed-bottom .btn{
    width: 7.1rem;
    height: .8rem;
    line-height: .8rem;
    background: #FFE800;
    border-radius: .4rem;
    text-align: center;
    font-size: .34rem;
    font-weight: bold;
    padding: 0;
  }
</style>




// WEBPACK FOOTER //
// OnlineComment.vue?160c9341